import Vue from 'vue'
export function push(callback,url,params={},mask=true,error=false){
    Vue.prototype.curl.post(url,params,mask).then((e) => {
        if(e.data.code==-3){
            Vue.prototype.curl.token(function(){ Vue.prototype.obtain.push(callback,url,params,mask) }) 
        }else if(e.data.code==-2){
            sessionStorage.removeItem('voucher')
            localStorage.removeItem('voucher')
            Vue.prototype.curl.create(function(){ Vue.prototype.obtain.push(callback,url,params,mask) }) 
        }else if(e.data.code==0){
            if(typeof callback == "function") callback(e.data.data)
        }else if(e.data.code==-9){
            Vue.prototype.common.logout()
        }else{
            if(error){
                if(typeof callback == "function") callback(e.data)
            }else{
                if(e.data.msg){
                    Vue.prototype.$notify({ type: 'warning', message: e.data.msg, duration: Vue.prototype.global.msg_duration })
                    // Vue.prototype.$dialog({ message: e.data.msg })
                }
            }
        }
    }).catch(err=>{ console.log(err) })
}

export function remove(callback,url,params={},mask=true,msg="此操作将永久删除该信息, 是否继续?"){
    Vue.prototype.$dialog.confirm({
        message: msg,
        confirmButtonText: Vue.prototype.lang.field('confirm'),
        cancelButtonText: Vue.prototype.lang.field('cancel'),
        cancelButtonColor: "#1989fa"
    }).then(() => {
        Vue.prototype.curl.post(url,params,mask).then((e) => {
            if(e.data.code==-3){
                Vue.prototype.curl.token(function(){ Vue.prototype.obtain.remove(callback,url,params,mask) }) 
            }else if(e.data.code==-2){
                sessionStorage.removeItem('voucher')
                localStorage.removeItem('voucher')
                Vue.prototype.curl.create(function(){ Vue.prototype.obtain.remove(callback,url,params,mask) }) 
            }else if(e.data.code==0){
                if(typeof callback == "function") callback(e.data.data)
            }else if(e.data.code==-9){
                Vue.prototype.common.logout()
            }else{
                if(e.data.msg){
                    Vue.prototype.$notify({ type: 'warning', message: e.data.msg, duration: Vue.prototype.global.msg_duration })
                    // Vue.prototype.$dialog({ message: e.data.msg })
                }
                
            }
        }).catch(err=>{ console.log(err) })
    }).catch(() => {});
}

export function file(callback,url,params={},mask=true){
    Vue.prototype.curl.file(url,params,mask).then((e) => {
        if(e.data.code==-3){
            Vue.prototype.curl.token(function(){ Vue.prototype.obtain.file(callback,url,params,mask) }) 
        }else if(e.data.code==-2){
            sessionStorage.removeItem('voucher')
            localStorage.removeItem('voucher')
            Vue.prototype.curl.create(function(){ Vue.prototype.obtain.file(callback,url,params,mask) }) 
        }else if(e.data.code==0){
            if(typeof callback == "function") callback(e.data.data)
        }else if(e.data.code==-9){
            Vue.prototype.common.logout()
        }else{
            console.log(e.data)
            if(e.data.msg){
                Vue.prototype.$notify({ type: 'warning', message: e.data.msg, duration: Vue.prototype.global.msg_duration })
                // Vue.prototype.$dialog({ message: e.data.msg })
            }
        }
    }).catch(err=>{ console.log(err) })
}

export function jssdk(callback){
    let params = {}
    if(Vue.prototype.common.isIos()){
        params.url = sessionStorage.getItem('wxsdk_url')
    }
    Vue.prototype.obtain.push(
        data=>{
            if(typeof callback == "function") callback(data)
        },
        '/app/wechat/jssdk',params,false
    )
}
export default { push, remove, file, jssdk }


// WEBPACK FOOTER //
// ./src/utils/obtain.js